.root {
  display: var(--haus-relatedProducts__root__display, flex);
  flex-direction: var(--haus-relatedProducts__root__flex-direction, column);
  gap: var(--haus-relatedProducts__root__gap, 24px);
}

.controls {
  display: var(--haus-relatedProducts__controls__display, flex);
  justify-content: var(--haus-relatedProducts__controls__justify-content, flex-end);
}

.controlsHidden {
  visibility: var(--haus-relatedProducts__controlsHidden__visibility, hidden);
  pointer-events: var(--haus-relatedProducts__controlsHidden__pointer-events, none);
}

.arrowControls {
  display: var(--haus-relatedProducts__arrowControls__display, inline-flex);
  align-items: var(--haus-relatedProducts__arrowControls__align-items, center);
  gap: var(--haus-relatedProducts__arrowControls__gap, 8px);
}

.progressBar {
  color: var(--haus-relatedProducts__progressBar__color, var(--haus-color-body, #111));
}

@media (max-width: 767px) {
  .controls {
    display: none;
  }

  .progressBar {
    --haus-carousel__progress__height: var(--haus-relatedProducts__progressBar__height, 4px);
    --haus-carousel__progress__background: var(
      --haus-relatedProducts__progressBar__background,
      rgba(0, 0, 0, 0.12)
    );
    --haus-carousel__progressIndicator__background: var(
      --haus-relatedProducts__progressBar__indicator-background,
      var(--haus-color-body, #111)
    );
  }
}

.status {
  display: var(--haus-relatedProducts__status__display, flex);
  justify-content: var(--haus-relatedProducts__status__justify-content, center);
  align-items: var(--haus-relatedProducts__status__align-items, center);
  min-height: var(--haus-relatedProducts__status__min-height, 80px);
  text-align: var(--haus-relatedProducts__status__text-align, center);
}

.errorText {
  color: var(--haus-relatedProducts__errorText__color, var(--haus-color-error, #e53e3e));
}
